/* Approved Cart A. Enhances native UpCart; never owns checkout or paid item rows. */
(function () {
  'use strict';
  var configNode = document.getElementById('ll-cart-a-config');
  if (!configNode || window.LN_B2B || !document.documentElement.classList.contains('ll-theme')) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  if (!config.enabled || window.__llCartAUI) return;
  window.__llCartAUI = true;
  function decode(value){var t=document.createElement('textarea');t.innerHTML=String(value || '');return t.value;}
  Object.keys(config.text).forEach(function(k){config.text[k]=decode(config.text[k]);});
  config.giftCatalog.forEach(function(g){g.name=decode(g.name);});
  config.products = config.products.filter(function (p) { return p.data && p.data.id; }).map(function (p) {
    return Object.assign({}, p.data, { key: p.key, title: decode(p.title), benefit: decode(p.benefit), image: p.image });
  });
  // Recommendation-only products (Kids Sleep, Adults Multi). Kept out of
  // config.products so they never get plan controls or the kids gift rules.
  config.crossSells = (config.crossSells || []).filter(function (p) { return p.data && p.data.id; }).map(function (p) {
    return Object.assign({}, p.data, { key: p.key, title: decode(p.title), benefit: decode(p.benefit), heading: decode(p.heading), image: p.image, crossSell: true, planId: p.planId, planLabel: p.planLabel });
  });
  window.LLCartAConfig = config;
  var text = config.text, api, root, host, observer, cart = null, busy = false, errorText = '', styleReady = false;
  var focusIntent = null, restoreFocus = false, presentedCart = null;
  var focusRestoreUntil = 0, focusRestoreTimer = 0, focusRestoreStarted = false, lastRestoredFocus = null;
  var modalState = { open: false, popup: null, returnTo: null, outsideFocus: null, inert: new Map(), bound: false };
  var nativePaintQueued = false, emptyPaintDeadline = 0, emptyPaintTimer = 0, rowPaintDeadline = 0, rowPaintTimer = 0;
  var frame = 0, readTimer = 0, readDueAt = 0, reading = false, queuedRead = false, started = false, registered = {}, extrasSignature = '';
  var PREFIX = '.upcart-public-component-product-tile__';
  function $(selector, within) { return (within || root).querySelector(selector); }
  function all(selector, within) { return Array.from((within || root).querySelectorAll(selector)); }
  function esc(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (cart && cart.currency) || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
  }
  function phrase(key, values) {
    var out = (text[key] || key).replace(/__(price|value|amount)__/g, '{$1}');
    Object.keys(values || {}).forEach(function (k) { out = out.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}|\\{' + k + '\\}', 'g'), values[k]); });
    return out;
  }
  function isGift(item) { return item.product_type === 'Free Gift' && item.original_price === 0; }
  function giftVariantCounts(items) {
    var counts = new Map();
    items.forEach(function (item) { counts.set(item.variant_id, (counts.get(item.variant_id) || 0) + 1); });
    return counts;
  }
  function giftFor(item, variantCounts) {
    // Compact controls identify a gift by variant. Split lines (including paid
    // copies or different plans) keep every native row and its precise controls.
    if (!item || !isGift(item) || variantCounts && variantCounts.get(item.variant_id) !== 1) return null;
    var gift = config.giftCatalog.find(function (candidate) { return candidate.id === item.variant_id; });
    if (gift) return gift;
    // The Wellness bundle earns a different sticker SKU. This is presentation
    // metadata only: never add it to the regular cart's automatic gift rules.
    if (item.variant_id !== 54280090452281 && sleepIds.indexOf(item.variant_id) === -1) return null;
    var name = item.product_title || item.title;
    var image = sleepImages[item.variant_id] || item.featured_image && (item.featured_image.url || item.featured_image.src) || item.image;
    if (!name || typeof image !== 'string' || !image) return null;
    return { id: item.variant_id, value: 1000, name: name, image: image };
  }
  // Kids Sleep has no ladder: its gifts sit on one line in the Sleep card, not in the tray.
  var sleepGift = config.sleepGift || {}, sleepIds = (sleepGift.gifts || []).map(Number), sleepImages = sleepGift.images || {};
  function sleepPaid(items) { return items.some(function (item) { return !isGift(item) && (sleepGift.handles || []).indexOf(item.handle) !== -1; }); }
  function sleepLineGifts(items) {
    if (!sleepPaid(items)) return [];
    var counts = giftVariantCounts(items), tray = giftPresentation(items, items.some(function (item) { return !!api.plansFor(item); })).map(function (gift) { return gift.id; });
    return items.map(function (item) { var gift = giftFor(item, counts); return gift && sleepIds.indexOf(gift.id) !== -1 && tray.indexOf(gift.id) === -1 ? gift : null; }).filter(Boolean)
      .sort(function (a, b) { return sleepIds.indexOf(a.id) - sleepIds.indexOf(b.id); });
  }
  function giftPresentation(items, showPreviews) {
    var earned = new Map(), variantCounts = giftVariantCounts(items), sleepOn = sleepPaid(items);
    items.forEach(function (item) { var gift = giftFor(item, variantCounts); if (gift) earned.set(gift.id, Object.assign({}, gift, { qty: Number(item.quantity) || 1 })); });
    var gifts = config.giftCatalog.filter(function (gift) { return !(variantCounts.get(gift.id) > 1) && (showPreviews || earned.has(gift.id) && !(sleepOn && sleepIds.indexOf(gift.id) !== -1)); }).map(function (gift) {
      return Object.assign({}, gift, { free: earned.has(gift.id), qty: earned.has(gift.id) ? earned.get(gift.id).qty : 1 });
    });
    earned.forEach(function (gift) {
      if (!config.giftCatalog.some(function (candidate) { return candidate.id === gift.id; }) && !(sleepOn && sleepIds.indexOf(gift.id) !== -1)) gifts.unshift(Object.assign({}, gift, { free: true }));
    });
    return gifts;
  }
  function node(tag, className, value) { var el = document.createElement(tag); el.className = className; if (value != null) el.textContent = value; return el; }
  function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  function schedule() { if (!frame) frame = requestAnimationFrame(function () { frame = 0; render(); }); }
  function renderNativeMutation() {
    // Repair the first native replacement before paint, but bound synchronous
    // work if another legacy observer responds with further mutations.
    if (nativePaintQueued && !rowPaintDeadline) { schedule(); return; }
    nativePaintQueued = true;
    requestAnimationFrame(function () { nativePaintQueued = false; });
    render();
  }
  function observe() { observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class','aria-hidden'] }); }
  function clearCartFocusIntent() {
    focusIntent = null; restoreFocus = false; focusRestoreUntil = 0; focusRestoreStarted = false; lastRestoredFocus = null;
    if (focusRestoreTimer) { clearTimeout(focusRestoreTimer); focusRestoreTimer = 0; }
  }
  function setCartFocusIntent(intent, ready) {
    clearCartFocusIntent(); focusIntent = intent; restoreFocus = !!ready;
  }
  function restoreCartFocus() {
    if (!restoreFocus || !focusIntent || busy) return;
    if (!modalState.open) { clearCartFocusIntent(); return; }
    if (!focusRestoreUntil) focusRestoreUntil = Date.now() + 6000;
    if (Date.now() >= focusRestoreUntil) { clearCartFocusIntent(); return; }
    var target = focusIntent.gift ? $('.ll-cart-gifts__value') : $('.ll-cart-plan[data-variant="' + focusIntent.variant + '"]');
    var active = root.activeElement;
    if (target && !target.disabled && target.getClientRects().length) {
      if (!focusRestoreStarted || !active || active.disabled || !active.isConnected || active === lastRestoredFocus) {
        if (focusIntent.gift && !target.hasAttribute('tabindex')) target.tabIndex = -1;
        if (active !== target) target.focus({preventScroll:true});
        lastRestoredFocus = target; focusRestoreStarted = true;
      } else if (active !== target) {
        // A user or another dialog moved focus to a connected control. Respect it.
        clearCartFocusIntent(); return;
      }
    }
    // UpCart can replace a row again after the mutation completes. Reclaim only
    // lost focus for a bounded window; any new keyboard/pointer action cancels it.
    if (!focusRestoreTimer) focusRestoreTimer = setTimeout(function () { focusRestoreTimer = 0; schedule(); }, 250);
  }
  function reconcileCartModal() {
    if (!root || !host) return;
    var popup = $('#CartPopup');
    var inScope = config.enabled && !window.LN_B2B && document.documentElement.classList.contains('ll-theme');
    var open = !!(inScope && popup && popup.classList.contains('styles_active__'));
    function focusables() {
      if (!modalState.popup) return [];
      return all('a[href],button,input:not([type="hidden"]),select,textarea,[tabindex],[contenteditable="true"],summary,iframe', modalState.popup).filter(function (element) {
        return !element.disabled && element.tabIndex >= 0 && element.getClientRects().length &&
          !element.closest('[hidden],[inert],[aria-hidden="true"]') && getComputedStyle(element).visibility !== 'hidden';
      }).sort(function (a,b) { return (a.tabIndex > 0 ? a.tabIndex : Infinity) - (b.tabIndex > 0 ? b.tabIndex : Infinity); });
    }
    function focusInitial() {
      var close = $('.upcart-public-header__close-button', modalState.popup);
      var target = close && !close.disabled && close.getClientRects().length ? close : focusables()[0] || modalState.popup;
      if (target) target.focus({preventScroll:true});
    }
    if (!modalState.bound) {
      modalState.bound = true;
      document.addEventListener('focusin', function (event) {
        var path = event.composedPath();
        if (path.indexOf(host) === -1) {
          if (!modalState.open) modalState.outsideFocus = event.target;
          else focusInitial();
        }
      }, true);
      document.addEventListener('pointerdown', function () { host.removeAttribute('data-ll-cart-keyboard'); clearCartFocusIntent(); }, true);
      document.addEventListener('keydown', function (event) {
        if (!event.metaKey && !event.ctrlKey && !event.altKey) host.setAttribute('data-ll-cart-keyboard','');
        clearCartFocusIntent();
        if (!modalState.open || window.LN_B2B || !document.documentElement.classList.contains('ll-theme')) return;
        if (event.key === 'Escape') {
          var close = $('.upcart-public-header__close-button', modalState.popup);
          if (close) { event.preventDefault(); event.stopPropagation(); close.click(); }
          return;
        }
        if (event.key !== 'Tab') return;
        var controls = focusables(), active = root.activeElement;
        if (!controls.length) { event.preventDefault(); modalState.popup.focus({preventScroll:true}); return; }
        var first = controls[0], last = controls[controls.length - 1];
        if (!active || active === modalState.popup || !modalState.popup.contains(active)) {
          event.preventDefault(); (event.shiftKey ? last : first).focus({preventScroll:true});
        } else if (event.shiftKey && active === first) {
          event.preventDefault(); last.focus({preventScroll:true});
        } else if (!event.shiftKey && active === last) {
          event.preventDefault(); first.focus({preventScroll:true});
        }
      }, true);
    }
    if (open) {
      var heading = $('[data-upcart-chunk="header-title-content"]', popup) || $('.upcart-public-header__title', popup) || $('h1,h2,h3,h4', popup);
      if (heading && !heading.id) heading.id = 'll-cart-dialog-title';
      if (popup.getAttribute('role') !== 'dialog') popup.setAttribute('role','dialog');
      if (popup.getAttribute('aria-modal') !== 'true') popup.setAttribute('aria-modal','true');
      if (heading && popup.getAttribute('aria-labelledby') !== heading.id) popup.setAttribute('aria-labelledby', heading.id);
      if (!modalState.open) {
        var active = document.activeElement;
        modalState.returnTo = active && active !== document.body && active !== host && !host.contains(active) ? active : modalState.outsideFocus;
      }
      for (var branch = host, parent = branch.parentElement; parent && parent !== document.documentElement; branch = parent, parent = parent.parentElement) {
        Array.from(parent.children).forEach(function (sibling) {
          if (sibling === branch || modalState.inert.has(sibling)) return;
          modalState.inert.set(sibling, sibling.inert); sibling.inert = true;
        });
      }
      var justOpened = !modalState.open, replaced = modalState.popup !== popup;
      modalState.open = true; modalState.popup = popup;
      if (justOpened || (replaced && !focusIntent)) focusInitial();
    } else {
      if (modalState.popup && modalState.popup.getAttribute('aria-modal') === 'true') modalState.popup.removeAttribute('aria-modal');
      if (!modalState.open && !modalState.inert.size) return;
      modalState.open = false; modalState.popup = popup;
      modalState.inert.forEach(function (prior, element) { element.inert = prior; });
      modalState.inert.clear(); clearCartFocusIntent();
      var target = modalState.returnTo;
      if (!target || !target.isConnected || target.disabled || !target.getClientRects().length) target = document.querySelector('[data-ll-cart-open]');
      modalState.returnTo = null;
      if (target && target.isConnected && !target.closest('[inert]')) target.focus({preventScroll:true});
    }
  }
  function queueRead(delay) {
    delay = delay == null ? 400 : delay;
    var dueAt = Date.now() + delay;
    // Loaded/opened events can follow an update for the same native refresh.
    // Keep the earliest check instead of letting a slower event postpone it.
    if (readTimer && readDueAt <= dueAt) return;
    clearTimeout(readTimer);
    readDueAt = dueAt;
    readTimer = setTimeout(function () {
      readTimer = 0; readDueAt = 0;
      if (!api || busy) { queuedRead = true; return; }
      if (reading) { queuedRead = true; return; }
      reading = true; queuedRead = false;
      api.readCart().catch(function () {}).finally(function () { reading = false; if (queuedRead && !busy) queueRead(900); });
    }, delay);
  }
  function queueNativeRead(name) {
    // Update events fire after the native mutation. Coalesce the two UpCart
    // event APIs briefly, then confirm promptly. Commerce still owns the
    // independent gift/offer settlement delays and checkout lock.
    // A quantity change uses upcartRefreshCart(), which can report Loaded even
    // after initialization. Only the first load retains the startup delay.
    queueRead(/Opened|drawer-opened/.test(name) || (/Loaded/.test(name) && !cart) ? 700 : 150);
  }
  function rowItem(row) {
    var anchor = $(PREFIX + 'title-link', row);
    if (!anchor) return null;
    var url;
    try { url = new URL(anchor.href, location.href); } catch (e) { return null; }
    var variant = Number(url.searchParams.get('variant'));
    var plan = url.searchParams.get('selling_plan');
    // Never identify a duplicate variant by its DOM position. Unknown identity keeps native UI.
    var matches = cart.items.filter(function (item) {
      var itemPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
      return item.variant_id === variant && String(itemPlan || '') === String(plan || '');
    });
    return matches.length === 1 ? matches[0] : null;
  }
  function plansOnRow(row, item, plans) {
    var controls = $('.ln-set-row', row) || $(PREFIX + 'controls', row);
    if (!controls) return;
    var select = $('.ll-cart-plan', row);
    if (!select) {
      select = node('select', 'll-cart-plan');
      select.setAttribute('data-heatmap-id', 'cart-plan');
      select.addEventListener('change', function (event) {
        event.stopPropagation();
        var key = select.dataset.itemKey;
        setCartFocusIntent({variant: select.dataset.variant});
        api.changePlan(key, select.value).catch(function () {}).finally(schedule);
      });
    }
    if (select.parentNode !== controls) controls.prepend(select);
    var choices = ['otp','monthly','quarterly'].filter(function (kind) { return plans[kind]; });
    var choiceSignature = choices.join(',');
    if (select.dataset.choices !== choiceSignature) {
      select.innerHTML = choices.map(function (kind) { return '<option value="' + kind + '">' + esc(text[kind]) + '</option>'; }).join('');
      select.dataset.choices = choiceSignature;
    }
    select.dataset.itemKey = item.key;
    select.dataset.variant = item.variant_id;
    select.setAttribute('aria-label', 'Delivery plan for ' + (api.productFor(item).title || item.product_title));
    if (select.value !== plans.kind) select.value = plans.kind;
    select.disabled = busy;
    row.dataset.llCartPlan = plans.kind;
  }
  function presentationFor(item) {
    if (!item || isGift(item)) return null;
    if (item.handle === 'kids-wellness-bundle') {
      // Same shape as single products: benefit first, then the product name.
      return {key:'wellness', includedKeys:['multi','digestion','immunity'],
        benefit:text.bundle_benefit || 'Kids Complete Wellness Bundle', title:text.bundle_name || 'Multi + Pre & Probiotic + Elderberry'};
    }
    // Presentation may recognize a box SKU without making its Skio plan editable
    // through the standard-plan adapter. Commerce eligibility stays unchanged.
    var product = config.products.find(function (p) {
      return p.variants.some(function (v) { return String(v.id) === String(item.variant_id); });
    });
    if (product) return product;
    var crossSell = config.crossSells.find(function (p) { return p.key === item.handle; });
    if (crossSell) return crossSell;
    if (!item.handle || !document.querySelector) return null;
    var kids = document.querySelector('.ll-drawer__products');
    var link = kids && Array.from(kids.querySelectorAll('a[href]')).find(function (a) {
      return new URL(a.href, location.href).pathname === '/products/' + item.handle;
    });
    var benefit = link && link.querySelector('strong'), title = link && link.querySelector('small');
    return benefit && title ? {key: item.handle, benefit: benefit.textContent, title: title.textContent} : null;
  }
  function planLabel(item) {
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (!plan) return text.otp;
    if (Number(plan.id) === config.planIds.quarterly) return text.quarterly;
    // Every 30-day plan (standard, bundle or box) reads as the approved "Monthly".
    if (Number(plan.id) === config.planIds.monthly || /^Every 30 Days$/i.test(String(plan.name || '').trim())) return text.monthly;
    return plan.name;
  }
  function renderRows() {
    var giftCounts = giftVariantCounts(cart.items);
    if(cart.currency==='USD')all('[data-upcart-chunk="cart-item-price"],[data-upcart-chunk="cart-item-compare-at-price"],.ln-subtotal-was,[class*="Footer__cartSubtotalValue"]').forEach(function(el){
      Array.from(el.childNodes).filter(function(n){return n.nodeType===3;}).forEach(function(n){var compact=n.textContent.replace(/(\$[\d,]+)\.00\b/g,'$1');if(n.textContent!==compact)n.textContent=compact;});
    });
    all('li.upcart-public-cart-item').forEach(function (row) {
      var item = rowItem(row);
      var knownGift = !!giftFor(item, giftCounts);
      row.toggleAttribute('data-ll-cart-gift', !!knownGift);
      var product = item && api.productFor(item), plans = item && api.plansFor(item);
      var known = !!product && !!plans && plans.kind !== 'unknown';
      row.toggleAttribute('data-ll-cart-known', known);
      row.toggleAttribute('data-ll-cart-native', !known && !knownGift);
      if (!known) {
        all('.ll-cart-renewal,.ll-cart-plan', row).forEach(function (e) { e.remove(); });
        all('select option', row).forEach(function (option) {
          // The legacy rescue guard reads textContent. Use the native display
          // label so that guard, the plan value and the change event stay intact.
          if (/^Dynamic Box Subscription\s*\/\s*Every 30 Days$/i.test(option.textContent.trim())) {
            option.label = text.monthly + ' · Bundle & Save';
          }
        });
        var display = presentationFor(item), nativeInfo = $(PREFIX + 'info', row), nativeBenefit = $('.ll-cart-benefit', row);
        var nativeControls = $(PREFIX + 'controls', row), pill = $('.ll-cart-plan-static', row);
        // Rows whose plan is shown as a fixed label (no native plan select) get
        // the single-product layout: plan pill + quantity on one line.
        var liveSelect = all('select', row).some(function (s) { return getComputedStyle(s).display !== 'none'; });
        var compact = !!(display && nativeInfo && nativeControls && !liveSelect);
        row.toggleAttribute('data-ll-cart-display', compact);
        if (display && nativeInfo) {
          if (!nativeBenefit) { nativeBenefit = node('div', 'll-cart-benefit'); nativeInfo.prepend(nativeBenefit); }
          setText(nativeBenefit, display.benefit);
          setText($(PREFIX + 'title-link', row), display.title);
        } else if (nativeBenefit) nativeBenefit.remove();
        var sleepLine = $('.ll-cart-sleep-gifts', row), lineGifts = item && !isGift(item) && (sleepGift.handles || []).indexOf(item.handle) !== -1 ? sleepLineGifts(cart.items) : [];
        if (lineGifts.length) {
          var lineSig = JSON.stringify([lineGifts.map(function (gift) { return [gift.id, gift.image]; }), cart.currency]);
          if (!sleepLine) { sleepLine = node('div', 'll-cart-sleep-gifts'); sleepLine.setAttribute('data-heatmap-id', 'cart-sleep-gifts'); row.append(sleepLine); }
          if (sleepLine.dataset.sig !== lineSig) {
            sleepLine.dataset.sig = lineSig;
            var lineValue = lineGifts.reduce(function (sum, gift) { return sum + (gift.value || 0); }, 0);
            sleepLine.innerHTML = '<span class="ll-cart-sleep-gifts__thumbs">' + lineGifts.map(function (gift) { return '<img src="' + esc(gift.image) + '" alt="" width="32" height="32" loading="lazy">'; }).join('') + '</span>'
              + '<span class="ll-cart-sleep-gifts__names">' + esc(lineGifts.map(function (gift) { return gift.name; }).join(' + ')) + '</span>'
              + '<span class="ll-cart-sleep-gifts__price">' + (lineValue ? '<s>' + esc(money(lineValue)) + '</s>' : '') + '<span class="ll-cart-gift__badge">' + esc(text.free) + '</span></span>';
          }
        } else if (sleepLine) sleepLine.remove();
        if (compact) {
          if (!pill) pill = node('span', 'll-cart-plan-static');
          if (pill.parentNode !== nativeControls) nativeControls.prepend(pill);
          setText(pill, planLabel(item));
        } else if (pill) pill.remove();
        return;
      }
      var info = $(PREFIX + 'info', row), header = $(PREFIX + 'header', row);
      if (!info || !header) return;
      var benefit = $('.ll-cart-benefit', row);
      if (!benefit) { benefit = node('div', 'll-cart-benefit'); info.prepend(benefit); }
      setText(benefit, product.benefit);
      // Native title remains a real product link, with an approved concise display label.
      setText($(PREFIX + 'title-link', row), product.title);
      plansOnRow(row, item, plans);
      var renewal = $('.ll-cart-renewal', row), selected = plans[plans.kind];
      var renewalPrice = selected && selected.renewalPrice;
      var showRenewal = plans.kind !== 'otp' && Number.isFinite(renewalPrice) && renewalPrice * item.quantity !== item.final_line_price;
      if (showRenewal) {
        if (!renewal) { renewal = node('div','ll-cart-renewal'); header.after(renewal); }
        setText(renewal, phrase('renewal', { price: money(renewalPrice * item.quantity) }));
        renewal.setAttribute('aria-label', phrase('renewal', { price: money(renewalPrice * item.quantity) }) + (plans.kind === 'quarterly' ? ' every 3 months' : ' every month'));
      } else if (renewal) renewal.remove();
    });
  }
  function pickCrossSell() {
    var have = {}, paid = cart.items.filter(function (item) { return !isGift(item); });
    // Box lines can receive a clearly labeled standalone Monthly recommendation
    // while their existing bundle plans and properties remain owned by Skio.
    paid.forEach(function (item) {
      var p = presentationFor(item);
      if (p) (p.includedKeys || [p.key]).forEach(function(key){ have[key] = true; });
    });
    if (!Object.keys(have).length || paid.some(function(item){return !presentationFor(item);})) return null;
    var pairs = {multi:['digestion','immunity'],digestion:['multi','immunity'],immunity:['multi','digestion']}, scores = {};
    Object.keys(have).forEach(function (key) { (pairs[key] || ['multi','digestion','immunity']).forEach(function (missing, i) { if (!have[missing]) scores[missing] = (scores[missing] || 0) + 3 - i; }); });
    function monthlyReady(product) {
      return product.variants.some(function (v) { return v.available && (v.selling_plan_allocations || []).some(function (a) { return Number(a.selling_plan_id) === (product.planId || config.planIds.monthly); }); });
    }
    var kids = config.products.filter(function (product) { return scores[product.key] && monthlyReady(product); })
      .sort(function (a,b) { return scores[b.key] - scores[a.key]; })[0];
    if (kids) return kids;
    // The daytime kids routine is complete (e.g. the Wellness bundle): offer
    // Kids Sleep next, then the parent's own multi.
    if (!config.products.every(function (product) { return have[product.key]; })) return null;
    return config.crossSells.filter(function (product) { return !have[product.key] && product.heading && monthlyReady(product); })[0] || null;
  }
  function renderExtras() {
    var ul = $('ul.upcart-public-cart-items');
    if (!ul || !cart.items.length) { var stale = $('.ll-cart-extras'); if(stale) stale.remove(); host.removeAttribute('data-ll-cart-kids'); extrasSignature=''; return; }
    var extras = $('.ll-cart-extras');
    if (!extras) { extras = node('div','ll-cart-extras'); ul.after(extras); extrasSignature = ''; }
    var knownItems = cart.items.filter(function (item) { return !!api.plansFor(item); });
    var eligible = knownItems.filter(function (item) { return api.plansFor(item).kind === 'monthly' && api.plansFor(item).quarterly; });
    eligible.sort(function (a,b) { return (api.plansFor(a).kind === 'monthly' ? -1 : 1) - (api.plansFor(b).kind === 'monthly' ? -1 : 1); });
    var upgradeItem = eligible[0], cross = pickCrossSell();
    var hasKnown = knownItems.length > 0;
    var gifts = giftPresentation(cart.items, hasKnown);
    var earned = gifts.filter(function (gift) { return gift.free; });
    var value = earned.reduce(function (sum,g) { return sum + g.value * (g.qty || 1); }, 0);
    var anyQ = knownItems.some(function(i){return api.plansFor(i).kind==='quarterly';});
    var allOtp = hasKnown && cart.items.filter(function(i){return !isGift(i);}).every(function(i){var plans=api.plansFor(i);return plans && plans.kind==='otp' && plans.monthly;});
    var canUpgrade = !!upgradeItem && !anyQ;
    var signature = JSON.stringify([gifts,upgradeItem && upgradeItem.key,cross && cross.key,allOtp,canUpgrade,hasKnown,cart.currency]);
    if (signature !== extrasSignature) {
      extrasSignature = signature;
      var html = '';
      if (hasKnown || earned.length) {
        html += '<section class="ll-cart-gifts" aria-label="Free gifts"><div class="ll-cart-gifts__head"><b class="ll-cart-gifts__value">' + esc(value ? phrase('gifts', {value:money(value)}) : 'Free Gifts') + '</b>';
        if (canUpgrade) html += '<button type="button" class="ll-cart-gifts__upgrade" data-ll-upgrade data-heatmap-id="cart-upgrade"' + (busy ? ' disabled' : '') + '>' + esc(text.upgrade) + '</button>';
        html += '</div>';
        if (canUpgrade && earned.length < config.giftCatalog.length) html += '<p class="ll-cart-gifts__nudge">' + esc(value ? text.upgrade_nudge : text.subscribe_nudge) + '</p>';
        html += '<div class="ll-cart-gifts__items">';
        gifts.forEach(function (gift) {
          var free = gift.free;
          html += '<div class="ll-cart-gift"><img class="ll-cart-gift__image" src="' + esc(gift.image) + '" alt="" width="64" height="64" loading="lazy"><span class="ll-cart-gift__badge' + (free ? '' : ' ll-cart-gift__badge--locked') + '">' + esc(free ? text.free : gift.tier === 'quarterly' ? text.locked : text.monthly) + '</span><span class="ll-cart-gift__name">' + esc(gift.name) + (free && gift.qty > 1 ? ' \u00D7' + gift.qty : '') + '</span>' + (free ? '<button type="button" class="ll-cart-gift__remove" data-ll-remove-gift="'+gift.id+'" aria-label="Remove '+esc(gift.name)+' gift" title="Remove gift">×</button>' : '') + '</div>';
        });
        html += '</div>';
        if(allOtp) html += '<button type="button" class="ll-cart-gifts__upgrade ll-cart-subscribe" data-ll-subscribe data-heatmap-id="cart-subscribe">' + esc(text.subscribe) + '</button>';
        html += '</section>';
      }
      if (cross) {
        var crossPlanId = cross.planId || config.planIds.monthly;
        var variant = cross.variants.find(function (v) { return v.available && (v.selling_plan_allocations || []).some(function (a) { return Number(a.selling_plan_id) === crossPlanId; }); });
        var allocation = variant.selling_plan_allocations.find(function(a){return Number(a.selling_plan_id)===crossPlanId;});
        html += '<section class="ll-cart-crosssell"><h3>' + esc(cross.heading || text.routine) + '</h3><div class="ll-cart-crosssell__row"><img class="ll-cart-crosssell__image" src="' + esc(cross.image) + '" alt="" width="72" height="72" loading="lazy"><div class="ll-cart-crosssell__info"><b class="ll-cart-crosssell__name">' + esc(cross.benefit) + '</b><div class="ll-cart-crosssell__meta">' + esc(cross.title.replace(/ · .+$/, '') + ' · ' + (cross.planLabel || text.monthly)) + '</div><div class="ll-cart-crosssell__prices"><span class="ll-cart-crosssell__price">' + esc(money(allocation.price)) + ' <s>' + esc(money(variant.price)) + '</s></span><button type="button" class="ll-cart-crosssell__button" data-ll-add="' + esc(cross.key) + '" data-heatmap-id="cart-monthly-cross-sell"' + (busy ? ' disabled' : '') + '>' + esc(text.add) + '</button></div></div></div></section>';
      }
      extras.innerHTML = html;
      all('[data-ll-remove-gift]',extras).forEach(function(button){button.addEventListener('click',function(){
        var row=all('li.upcart-public-cart-item').find(function(row){var item=rowItem(row);return item && isGift(item) && String(item.variant_id)===button.dataset.llRemoveGift;});
        var remove=row && $(PREFIX+'remove-button',row);if(remove){api.noteGiftRemoval(Number(button.dataset.llRemoveGift));setCartFocusIntent({gift:true},true);remove.click();}
      });});
      var upgrade = $('[data-ll-upgrade]', extras);
      if (upgrade) upgrade.addEventListener('click', function () { setCartFocusIntent({variant:String(upgradeItem.variant_id)}); api.upgradeMonthly().catch(function () {}); });
      var subscribeButton=$('[data-ll-subscribe]',extras);
      if(subscribeButton) subscribeButton.addEventListener('click',function(){setCartFocusIntent({variant:String(knownItems[0].variant_id)});api.subscribeAll().catch(function(){});});
      var add = $('[data-ll-add]', extras);
      if (add) add.addEventListener('click', function () {
        setCartFocusIntent({variant:String(cross.variants[0].id)});
        (cross.crossSell ? api.addCrossSell(add.dataset.llAdd) : api.addMonthly(add.dataset.llAdd)).catch(function () {});
      });
    }
    all('button',extras).forEach(function(b){b.disabled=busy;});
    host.toggleAttribute('data-ll-cart-kids', cart.items.some(function(item){return !!presentationFor(item);}) && cart.items.filter(function(item){return !isGift(item);}).every(function(item){return !!presentationFor(item);}));
  }
  function renderEmpty() {
    var body = $('.styles_CartPreview__empty__body__');
    var empty = !!(body && !cart.items.length);
    host.toggleAttribute('data-ll-cart-empty', empty);
    if (!empty) return;
    // A short recovery path, not a second navigation menu. Reuse approved
    // product labels and links so shoppers can choose flavor and plan first.
    if ($('.ll-cart-empty-menu', body)) return;
    var source = document.querySelector('.ll-drawer__body');
    if (!source || !source.querySelector('.ll-drawer__products a')) return;
    var menu = node('div', 'll-cart-empty-menu');
    var featured = source.querySelector('.ll-drawer__feature');
    if (featured) {
      var bundles = node('ul', 'll-drawer__products ll-cart-empty-bundles');
      var featuredItem = node('li', '');
      featuredItem.append(featured.cloneNode(true)); bundles.append(featuredItem); menu.append(bundles);
    }
    var bundle = source.querySelector('p a.ll-btn');
    if (bundle) menu.append(bundle.cloneNode(true));
    var products = node('ul', 'll-drawer__products');
    var handles = config.products.map(function (p) { return p.handle; }).concat([
      'organic-multivitamin-strawberry', 'adults-pre-probiotic-mixed-berry-organic'
    ]);
    handles.forEach(function (handle) {
      var link = Array.from(source.querySelectorAll('.ll-drawer__products a')).find(function (a) {
        return new URL(a.href, location.href).pathname === '/products/' + handle;
      });
      if (!link) return;
      var item = node('li', '');
      item.append(link.cloneNode(true));
      products.append(item);
    });
    if (!products.children.length) return;
    menu.append(products);
    var shopAll = source.querySelector('.ll-drawer__all');
    if (shopAll) menu.append(shopAll.cloneNode(true));
    all('[id],[data-shopify-editor-block]', menu).forEach(function (el) {
      el.removeAttribute('id'); el.removeAttribute('data-shopify-editor-block');
    });
    all('[data-heatmap-id-link],[data-heatmap-cta]', menu).forEach(function (el) {
      ['data-heatmap-id-link','data-heatmap-cta'].forEach(function (attr) {
        if (el.hasAttribute(attr)) el.setAttribute(attr, el.getAttribute(attr).replace('ll-drawer','ll-cart-empty'));
      });
    });
    body.append(menu);
    // Keep native recommendations as the fallback on pages without the menu.
    body.setAttribute('data-ll-empty-menu', '');
  }
  function renderSummary() {
    var paid = cart.items.filter(function (item) { return !isGift(item); });
    var header = $('[data-upcart-chunk="header-title-content"]');
    setText(header, text.cart + ' ( ' + paid.reduce(function (n,item) { return n + item.quantity; }, 0) + ' )');
    var body = $('.upcart-cart-body'), footer = $('.upcart-footer');
    if (!body || !footer) return;
    var banner = $('.ll-cart-banner');
    if (!banner) { banner = node('div','ll-cart-banner'); body.before(banner); }
    var hasSub = paid.some(function (item) { return item.selling_plan_allocation; });
    var freeShipping = (cart.currency === 'USD') && (hasSub || cart.total_price >= 7500);
    var bannerHtml = esc(freeShipping ? text.savings_shipping : text.standard_shipping);
    if (banner.innerHTML !== bannerHtml) banner.innerHTML = bannerHtml;
    banner.hidden = !paid.length;
    var shipping = $('.ll-cart-shipping');
    if (!shipping) { shipping = node('div','ll-cart-shipping'); footer.prepend(shipping); }
    var shippingHtml = '<span>' + esc(text.shipping) + '</span><b class="' + (freeShipping ? 'll-cart-shipping__free' : '') + '">' + esc(freeShipping ? text.free : text.shipping_checkout) + '</b>';
    if (shipping.innerHTML !== shippingHtml) shipping.innerHTML = shippingHtml;
    var subtotal = $('[class*="Footer__cartSubtotalTitle"]');
    if (subtotal) {
      var listTotal = paid.reduce(function (sum,item) { var p=api.productFor(item) || config.crossSells.find(function(c){return c.key===item.handle;}); var v=p && p.variants.find(function(v){return v.id===item.variant_id;}); return sum + (v ? v.price : item.original_price) * item.quantity; },0);
      var saved = listTotal - cart.total_price;
      // Seed compare-at from the same authoritative cart as savings, rather
      // than waiting for a separate legacy listener to insert it after opening.
      var compareAt = $('.ln-subtotal-was', subtotal), totalNode = $('[class*="Footer__cartSubtotalValue"]', subtotal);
      if (saved > 0 && totalNode && !compareAt) { compareAt = node('s', 'ln-subtotal-was'); totalNode.before(compareAt); }
      if (compareAt && saved > 0) setText(compareAt, money(listTotal));
      if (totalNode) setText(totalNode, money(cart.total_price));
      var savings = $('.ll-cart-savings',subtotal);
      if (saved > 0 && paid.every(function(item){return !!api.productFor(item) || !!presentationFor(item);})) {
        if (!savings) savings=node('span','ll-cart-savings');
        // UpCart can replace/reorder prices after this badge is created. Keep
        // savings before both prices on every render, including before the
        // legacy compare-at price has arrived.
        var firstPrice = $('.ln-subtotal-was',subtotal) || $('[class*="Footer__cartSubtotalValue"]',subtotal);
        if (firstPrice && savings.nextElementSibling !== firstPrice) firstPrice.before(savings);
        setText(savings, phrase('save',{amount:money(saved)}));
      } else if(savings) savings.remove();
    }
    var checkout = $('.upcart-checkout-button');
    if(checkout) { checkout.setAttribute('aria-busy',String(busy)); checkout.setAttribute('data-heatmap-id','cart-checkout'); }
    var trustItems = all('.ln-trust-row__item');
    if (trustItems.length > 1 && hasSub) {
      var item=trustItems[1];
      Array.from(item.childNodes).filter(function(n){return n.nodeType===3;}).forEach(function(n){if(n.textContent.trim() && n.textContent.trim()!==text.pause)n.textContent=' '+text.pause;});
    }
    var status = $('.ll-cart-status');
    if (!status) { status=node('div','ll-cart-status'); status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); footer.append(status); }
    setText(status, busy ? text.updating : errorText);
    status.hidden = !busy && !errorText;
    all('.upcart-public-component-product-tile__quantity-selector button,.ln-set-stepper button,.upcart-public-component-product-tile__remove-button,.upcart-checkout-button').forEach(function(el){if(busy)el.setAttribute('aria-disabled','true');else el.removeAttribute('aria-disabled');});
    host.toggleAttribute('data-ll-cart-busy',busy);
  }
  function ensureStyle(){
    if(!root)return;
    var link=root.querySelector('#ll-cart-a-style');
    if(!link){
      styleReady=false;host.removeAttribute('data-ll-cart-a');
      link=document.createElement('link');link.id='ll-cart-a-style';link.rel='stylesheet';link.href=config.cssUrl;
      link.onload=function(){if(link.getRootNode()===root){styleReady=true;schedule();}};
      link.onerror=function(){host.removeAttribute('data-ll-cart-a');};root.append(link);
    }else if(link.sheet){styleReady=true;}
  }
  function render() {
    reconcileCartModal();
    ensureStyle();
    if (!root || !cart || !styleReady || window.LN_B2B) return;
    // Keep the last confirmed presentation while UpCart replaces its old rows
    // with the empty body. Do not restyle those old rows against an empty cart.
    // The short fail-open deadline preserves native recovery if refresh fails.
    if (!cart.items.length && $('li.upcart-public-cart-item') && !errorText) {
      if (!emptyPaintDeadline) {
        emptyPaintDeadline = Date.now() + 1500;
        emptyPaintTimer = setTimeout(schedule, 1500);
      }
      if (Date.now() < emptyPaintDeadline) return;
    } else {
      emptyPaintDeadline = 0;
      if (emptyPaintTimer) { clearTimeout(emptyPaintTimer); emptyPaintTimer = 0; }
    }
    // A confirmed response can precede UpCart's replacement rows. Publish the
    // new savings, gifts and header together with those rows, not over the old
    // product list. Keep the existing updating status and bounded recovery.
    var rows = all('li.upcart-public-cart-item');
    var paid = cart.items.filter(function (item) { return !isGift(item); });
    var nativePaid = rows.filter(function (row) { var item = rowItem(row); return !item || !isGift(item); });
    var matched = nativePaid.length === paid.length && nativePaid.every(function (row) { var item = rowItem(row); return item && !isGift(item); });
    if (paid.length && (busy || rowPaintDeadline) && !matched && !errorText) {
      if (!rowPaintDeadline) { rowPaintDeadline = Date.now() + 2500; rowPaintTimer = setTimeout(schedule, 2500); }
      if (Date.now() < rowPaintDeadline) {
        // Native footer listeners may run before the native product commit too.
        // Retain the last displayed totals until all paid rows can be published.
        if (presentedCart) {
          var pendingCart = cart; cart = presentedCart; observer.disconnect();
          try { renderSummary(); } finally { cart = pendingCart; observe(); }
        }
        return;
      }
    } else {
      rowPaintDeadline = 0;
      if (rowPaintTimer) { clearTimeout(rowPaintTimer); rowPaintTimer = 0; }
    }
    observer.disconnect();
    try { renderRows(); renderExtras(); renderEmpty(); renderSummary(); presentedCart = cart; host.setAttribute('data-ll-cart-a',''); host.toggleAttribute('data-ll-cart-menu-ready', !!document.querySelector('.ll-drawer__products a')); }
    finally { observe(); }
    restoreCartFocus();
  }
  function registerEvents() {
    ['upcartSubscribeCartLoaded','upcartSubscribeCartUpdated','upcartSubscribeCartOpened','upcartSubscribeItemRemoved'].forEach(function (name) {
      if (!registered[name] && typeof window[name] === 'function') { registered[name]=true; window[name](function(){queueNativeRead(name);}); }
    });
  }
  function mount() {
    api = window.LLCartACommerce;
    host = document.getElementById('upCart');
    root = host && host.shadowRoot;
    if(host)host.setAttribute('data-heatmap-id','ll-cart-a');
    if (!api || !root || !root.querySelector('#CartPopup')) return false;
    if (started) return true;
    started=true;
    reconcileCartModal();
    ensureStyle();
    // Enhance native replacement nodes in the same microtask, before the browser
    // paints them. Deferring to the next animation frame exposed legacy markup.
    observer = new MutationObserver(renderNativeMutation); observe();
    ['click','change','keydown'].forEach(function(type){root.addEventListener(type,function(e){
      if(e.type==='keydown' && (e.key==='Tab' || e.key==='Escape')) return;
      if(busy && e.target.closest('.upcart-public-cart-item,.upcart-checkout-button,.ll-cart-extras')) { e.preventDefault();e.stopImmediatePropagation(); }
      else if (e.type === 'click' && e.target.closest(PREFIX + 'remove-button') && api.removeLastItem && cart) {
        var row = e.target.closest('li.upcart-public-cart-item'), item = row && rowItem(row);
        var paid = cart.items.filter(function (line) { return !isGift(line); });
        if (item && paid.length === 1 && paid[0].key === item.key && api.plansFor(item) &&
            cart.items.every(function (line) { return !isGift(line) || config.giftCatalog.some(function (gift) { return gift.id === line.variant_id; }); })) {
          e.preventDefault(); e.stopImmediatePropagation();
          api.removeLastItem(item.key).catch(function () {});
        }
      }
      else if(e.type==='click' && e.target.closest('.ln-set-stepper button') && api.noteNativeQuantityMutation) api.noteNativeQuantityMutation();
    },true);});
    api.subscribe(function(state){cart=state.cart || cart;if(busy && !state.busy)restoreFocus=true;busy=state.busy;errorText=state.error ? (state.error.message || text.error) : '';schedule();if(!busy && queuedRead)queueRead(900);});
    registerEvents();
    ['cart-updated','cart-item-added','cart-item-removed','cart-drawer-opened'].forEach(function(event){window.addEventListener('aftersell-upcart:public-events:'+event,function(){queueNativeRead(event);});});
    queueRead(0);
    return true;
  }
  var attempts=0, boot=setInterval(function(){attempts++;registerEvents();if(mount() || attempts>120)clearInterval(boot);},250);
})();
